import { render, staticRenderFns } from "./Ppob.vue?vue&type=template&id=b62cc7a6"
import script from "./Ppob.vue?vue&type=script&lang=js"
export * from "./Ppob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports